"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilestoneFieldGate = getMilestoneFieldGate;
exports.resolveRevisionMoneyState = resolveRevisionMoneyState;
exports.mapMoneyStateToDisplayLabel = mapMoneyStateToDisplayLabel;
exports.formatRevisionMoneyDisplayLabel = formatRevisionMoneyDisplayLabel;
exports.isMoneyStateStricter = isMoneyStateStricter;
exports.toDateOnly = toDateOnly;
exports.isStartDateLaterOnlyViolation = isStartDateLaterOnlyViolation;
const MILESTONE_GATES = {
    name: {
        scheduled_unpaid: "allow",
        funded: "allow_reason",
        partially_released: "allow_reason",
        fully_released: "lock",
    },
    description: {
        scheduled_unpaid: "allow",
        funded: "allow_reason",
        partially_released: "allow_reason",
        fully_released: "lock",
    },
    amount: {
        scheduled_unpaid: "lock",
        funded: "lock",
        partially_released: "lock",
        fully_released: "lock",
    },
    startDate: {
        scheduled_unpaid: "allow",
        funded: "later_only",
        partially_released: "later_only",
        fully_released: "lock",
    },
    endDate: {
        scheduled_unpaid: "allow",
        funded: "allow",
        partially_released: "allow",
        fully_released: "lock",
    },
    delete: {
        scheduled_unpaid: "allow_reason",
        funded: "lock",
        partially_released: "lock",
        fully_released: "lock",
    },
};
function getMilestoneFieldGate(field, moneyState) {
    return MILESTONE_GATES[field][moneyState];
}
function resolveRevisionMoneyState(input) {
    const budget = Number(input.budgetAmount ?? 0);
    const released = Number(input.releasedAmount ?? 0);
    const paymentRequestStatus = String(input.paymentRequestStatus || "").toLowerCase();
    if (paymentRequestStatus === "approved")
        return "fully_released";
    if (input.instantRelease && input.invoicePaid)
        return "fully_released";
    if (budget > 0 && released >= budget)
        return "fully_released";
    if (released > 0 && released < budget)
        return "partially_released";
    if (input.invoicePaid)
        return "funded";
    return "scheduled_unpaid";
}
function mapMoneyStateToDisplayLabel(moneyState) {
    if (moneyState === "scheduled_unpaid")
        return "pending";
    if (moneyState === "fully_released")
        return "released";
    return "in_escrow";
}
function formatRevisionMoneyDisplayLabel(label) {
    if (label === "pending")
        return "Pending";
    if (label === "in_escrow")
        return "In escrow";
    if (label === "released")
        return "Released";
    if (label === "draft")
        return "Draft";
    if (label === "deducted")
        return "Deducted";
    return "—";
}
function isMoneyStateStricter(from, to) {
    const rank = {
        scheduled_unpaid: 0,
        funded: 1,
        partially_released: 2,
        fully_released: 3,
    };
    return rank[to] > rank[from];
}
function toDateOnly(value) {
    if (value == null || value === "")
        return null;
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value))
        return value;
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime()))
        return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
function isStartDateLaterOnlyViolation(current, next) {
    const from = toDateOnly(current);
    const to = toDateOnly(next);
    if (!from || !to)
        return false;
    return to < from;
}
